// extracted by mini-css-extract-plugin
module.exports = {"viewTermText":"TermsScreen_viewTermText__1u5hM","table":"TermsScreen_table__3xCcF"};